import React from "react";
const show = v => v == null ? "—" : v;
export default function SeasonCard({ seasonView }) {
  const { rows, total, totalLabel } = seasonView;
  if (!rows.length) return <div className="fa-empty">No season statistics recorded yet.</div>;
  const headline = total || rows[0];
  return (
    <section className="fa-card" aria-label="Season">
      <h3>Season{seasonView.season ? ` · ${seasonView.season}` : ""}</h3>
      <span className="fa-scope">{total ? totalLabel : rows[0].competition}{seasonView.source === "pitchapi" ? " · recorded appearances" : ""}</span>
      <div className="fa-tiles four">
        <div className="fa-tile"><b>{show(headline.apps)}</b><span>Apps</span></div>
        <div className="fa-tile"><b>{show(headline.goals)}</b><span>Goals</span></div>
        <div className="fa-tile"><b>{show(headline.assists)}</b><span>Assists</span></div>
        <div className="fa-tile"><b>{show(headline.minutes)}</b><span>Mins</span></div>
      </div>
      {seasonView.warning && <p className="fa-note">{seasonView.warning}</p>}
      {rows.length > 1 && (
        <div className="fa-scroll" style={{ marginTop: 12 }}>
          <table className="fa-table">
            <thead><tr><th>Competition</th><th>App</th><th>Min</th><th>G</th><th>A</th></tr></thead>
            <tbody>{rows.map((r) => <tr key={r.key}><td>{r.competition}</td><td>{show(r.apps)}</td><td>{show(r.minutes)}</td><td>{show(r.goals)}</td><td>{show(r.assists)}</td></tr>)}</tbody>
          </table>
        </div>
      )}
    </section>
  );
}

